// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__XH6Sq","linkItem":"styles_linkItem__a6IXo","close":"styles_close__Bo2aQ","linkText":"styles_linkText__or9vI"};